import * as React from 'react';
import { useSelector } from 'react-redux';

import { DownloadAppBannerContainer } from '../DownloadAppBannerContainer';
import { LinkToFullVersionContainer } from '../LinkToFullVersionContainer';
import { MobileFooterLayout } from '../../components/MobileFooterLayout';
import { CianLogo } from '../../components/CianLogo';
import { MOBILE_FOOTER_TYPES } from '../../constants/footerTypes';
import { IApplicationState } from '../../types/redux';

export const MobileFooterContainer: React.FC = () => {
  const footerType = useSelector((state: IApplicationState) => state.footerType);

  if (!MOBILE_FOOTER_TYPES.includes(footerType)) {
    return null;
  }

  return (
    <MobileFooterLayout type={footerType}>
      <DownloadAppBannerContainer />
      <CianLogo />
      <LinkToFullVersionContainer />
    </MobileFooterLayout>
  );
};
